module.exports = __webpack_public_path__ + "img/page.38fb3cc4.png";